import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalHook() {
  return <section className="py-20 bg-white" data-id="element-48">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-50">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-8" data-id="element-51">
            ¿Te acordás de esa sensación?
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-700 font-medium" data-id="element-52">
            <p data-id="element-53">
              Abrir un sobre nuevo. Buscar la figurita que te faltaba. Pegar la
              última y cerrar el álbum completo.
            </p>
            <p data-id="element-54">
              Esa emoción que viviste de chico... el Mundial 2026 te la
              devuelve.
            </p>
            <p className="text-wc-red font-bold text-2xl mt-8" data-id="element-55">
              Pero hay algo que cambió.
            </p>
            <p data-id="element-56">
              Los sobres hoy cuestan una fortuna. Las figuritas difíciles nunca
              aparecen. Y cuando querés completar el álbum, terminás gastando el
              triple de lo que calculabas.
            </p>
            <p className="bg-gray-100 p-6 rounded-xl border-l-4 border-wc-blue italic text-gray-900 mt-8" data-id="element-57">
              ¿Y si pudieras tener todas las figuritas, de todos los equipos,
              listas para imprimir... por una fracción del costo?
            </p>
            <p className="font-bold text-wc-blue text-2xl" data-id="element-58">
              Eso es exactamente lo que vas a descubrir acá abajo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}